<template>
  <div class="hidden items-center md:flex" data-testid="breadcrumb">
    <component
      :is="item.url ? 'nuxt-link' : 'div'"
      v-for="(item, index) in MENU"
      :key="index"
      :to="item.url"
      class="text-xs leading-6 after:relative after:px-1 after:content-['>'] last:font-bold last:underline last:after:hidden"
      data-testid="breadcrumb-item"
    >
      <span v-if="item.url">{{ item.name }}</span>
      <span v-else>{{ item.name }}</span>
    </component>
  </div>
</template>

<script setup lang="ts">
import type { Ref } from 'vue'
import { defineProps, toRef } from 'vue'

const props = defineProps<{
  menu:
    | Ref<Array<{ name: string; url?: string }>>
    | Array<{ name: string; url?: string }>
}>()

const MENU = toRef(props.menu) as Ref<Array<{ name: string; url?: string }>>
</script>
